import { Link } from '@blissbook/ui/lib'
import Card from '../Card'
import Typography from '../Typography'

export default ({ post, ...props }) => {
  return (
    <Card
      {...props}
      color='aqua-500'
      title='A Personal Tour'
      titleCss={{ opacity: 0.5 }}
    >
      <Typography variant='p1' className='tw-mb-2'>
        Want to maybe work together? We'd love to learn about you and your
        project.
      </Typography>

      <Link
        className='btn btn-aqua btn-sm tw-mt-4 tw-block tw-font-semibold tw-text-lg'
        to='/request-a-demo'
      >
        Request a Demo
      </Link>
    </Card>
  )
}
